<template>
    <div>

        <list-page getter="purchases">
            <template v-slot:title="">
                Purchased Stock
            </template>
            <template v-slot:right_buttons="">
                <b-btn @click="openCreateNichibo()">Add Nichibo Stock</b-btn>
            </template>
        </list-page>

        <CreateByNichiboStockNo ref="createNichibo"/>
    </div>
</template>
<script>
    import ListPage from './ListPage'
    import CreateByNichiboStockNo from "./CreateByNichiboStockNo";
    export default {
        data() {
            return {
                show_nichibo_modal: false,
                messages: [],
            }
        },
        methods: {
            openCreateNichibo(){
                this.$refs.createNichibo.openModal()
            }
        },
        components: {
            'list-page': ListPage,
            CreateByNichiboStockNo
        },
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/PurchasedStock.vue